import { 
    faLinkedin,
    faGithubSquare,
  } from "@fortawesome/free-brands-svg-icons";
  import {
    faEnvelopeSquare,
    faLink
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const projectsArr = [
    {
      title: "WEATHER APP",
      screenshot: "https://eglehelms.dev/wp-content/uploads/2021/03/Weatherapp-thumb-1.jpg",
      description: 
      "Weather app that shows gets detailed forecast for current weather conditions in the given city/location and forecast for every 3 hours.",
      tech: "REACT JS | REST API | STYLED-COMPONENTS | NPM",
      code: "https://github.com/EgleHelms/weatherapp",
      demo: "https://eglehelms.github.io/weatherapp"
    },
    // {
    //   title: "MUSIC APP",
    //   screenshot: "https://www.apple.com/newsroom/images/product/app-store/apple_app_store_10th_anniversary_07102018_LP_hero.jpg.og.jpg",
    //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    //   tech: "REACT JS | REDUX | REST API",
    //   code: "ulr to code",
    //   demo: "ulr to demo"
    // },
    // {
    //   title: "POMODORO TIMER",
    //   screenshot: "https://www.apple.com/newsroom/images/product/app-store/apple_app_store_10th_anniversary_07102018_LP_hero.jpg.og.jpg",
    //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer.",
    //   tech: "REACT JS | SASS ",
    //   code: "ulr to code",
    //   demo: "ulr to demo"
    // },
    // {
    //   title: "BLOG",
    //   screenshot: "https://www.apple.com/newsroom/images/product/app-store/apple_app_store_10th_anniversary_07102018_LP_hero.jpg.og.jpg",
    //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an.",
    //   tech: "REACT JS | CRUD operations | SASS",
    //   code: "ulr to code",
    //   demo: "ulr to demo"
    // },
    // {
    //   title: "ECOMMERCE BOOK STORE",
    //   screenshot: "https://www.apple.com/newsroom/images/product/app-store/apple_app_store_10th_anniversary_07102018_LP_hero.jpg.og.jpg",
    //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an.",
    //   tech: "REACT JS | CRUD operations | SASS",
    //   code: "ulr to code",
    //   demo: "ulr to demo"
    // },
    {
      title: "PORTFOLIO PAGE",
      screenshot: "https://eglehelms.dev/wp-content/uploads/2021/03/portfolio-1.jpg",
      description: "My portfolio page displaying my recent projects.",
      tech: "REACT JS | SASS | NPM",
      code: "https://github.com/EgleHelms/eglehelms.github.io",
      demo: "https://eglehelms.github.io/"
    },
    {
      title: "POST-IT NOTES APP",
      screenshot: "https://eglehelms.dev/wp-content/uploads/2021/03/notes-thumb-1.jpg",
      description: "Sticky notes browser application with ability to store the notes created in the Local Storage.",
      tech: "VANILLA JS | HTML | CSS",
      code: "https://github.com/EgleHelms/stickynotes",
      demo: "https://eglehelms.github.io/stickynotes"
    },
    {
      title: "PASSWORD GENERATOR",
      screenshot: "https://eglehelms.dev/wp-content/uploads/2021/03/passgen-mockup-1.jpg",
      description: "Simple password generator with ability to control the character sets and number of characters.",
      tech: "VANILLA JS | HTML | CSS",
      code: "https://github.com/EgleHelms/password-generator",
      demo: "https://eglehelms.github.io/password-generator/"
    },
    {
      title: "CALCULATOR",
      screenshot: "https://eglehelms.dev/wp-content/uploads/2021/03/calculator-1.jpg",
      description: "Basic Calculator.",
      tech: "VANILLA JS | HTML | CSS",
      code: "https://github.com/EgleHelms/calculator",
      demo: "https://eglehelms.github.io/calculator/"
    }
  ];
  
  const socials = [
    {
      title: "LinkedIn",
      link: "https://www.linkedin.com/in/egle-helms/",
      icon: <FontAwesomeIcon icon={faLinkedin} />
    },
    {
      title: "GitHub",
      link: "https://www.linkedin.com/in/egle-helms/",
      icon: <FontAwesomeIcon icon={faGithubSquare} />
    },
    {
      title: "Email",
      link: "mailto:egle.helms@gmail.com",
      icon: <FontAwesomeIcon icon={faEnvelopeSquare} />
    },
    {
      title: "Resume",
      link: "https://eglehelms.dev/wp-content/uploads/2021/03/Egle-CV-public.pdf",
      icon: <FontAwesomeIcon icon={faLink} />
    }
  ]

  export {socials};
  export {projectsArr};